import React from 'react';
import { Chip } from '../Chip';
import { Text } from '../../../Text';
import * as S from './Chips.styles';
export const Chips = _ref => {
  let {
    selectedItems,
    isOpen,
    onClick,
    children,
    items,
    className
  } = _ref;
  return React.createElement(S.Wrapper, {
    className: className
  }, selectedItems.map((item, index) => {
    const newItem = items.find(filteredItem => filteredItem.value === item);
    if (!newItem) return null;
    if (isOpen) {
      return React.createElement(Chip, {
        key: newItem.id,
        hasDelete: true,
        "aria-label": "Remover ".concat(newItem.label, " dos itens selecionados"),
        onClick: () => onClick(newItem.value)
      }, newItem.label);
    }
    return React.createElement(Text.BodyMedium, {
      key: newItem.id,
      tag: "p"
    }, newItem.label, index === selectedItems.length - 1 ? '' : ', ');
  }), children);
};